import { useCallback, useEffect, useRef } from "react"

/**
 * Custom Hook to fetch more data when scrolling in lists
 * @param action The function that should be called when scrolled to the bottom of the page
 * @param offset The number of pixels from the bottom of the page at which the action should be called while scrolling. default 300
 *
 */
const DEFAULT_OFFSET = 300
export function useInfiniteScroll(action: () => void, offset?: number) {
	const actionRef = useRef(action)

	useEffect(() => {
		actionRef.current = action
	})

	const onScroll = useCallback(() => {
		const triggerPoint = window.document.body.clientHeight - (offset ?? DEFAULT_OFFSET)
		const viewportBottom = window.innerHeight + window.scrollY
		if (viewportBottom > triggerPoint) {
			actionRef.current()
		}
	}, [offset, actionRef])

	useEffect(() => {
		window.addEventListener("scroll", onScroll)
		return () => {
			window.removeEventListener("scroll", onScroll)
		}
	}, [onScroll])
}
